declare global {
  interface Window {
    __UPCLINIC_RUNTIME_CONFIG__?: {
      stripePublishableKey?: string;
      googleCustomSearchApiKey?: string;
      googleCustomSearchCx?: string;
      firebase?: Record<string, string>;
    };
  }
}

export function getStripePublishableKey(): string {
  if (typeof window !== 'undefined') {
    const runtimeKey = window.__UPCLINIC_RUNTIME_CONFIG__?.stripePublishableKey;
    if (runtimeKey) return runtimeKey;
  }

  return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
}

export function getGoogleCustomSearchApiKey(): string {
  if (typeof window !== 'undefined') {
    return window.__UPCLINIC_RUNTIME_CONFIG__?.googleCustomSearchApiKey || '';
  }
  return process.env.REACT_APP_GOOGLE_CUSTOM_SEARCH_API_KEY || '';
}

export function getGoogleCustomSearchCx(): string {
  if (typeof window !== 'undefined') {
    return window.__UPCLINIC_RUNTIME_CONFIG__?.googleCustomSearchCx || '';
  }
  return process.env.REACT_APP_GOOGLE_CUSTOM_SEARCH_CX || '';
}
